/**
 * Step 10 (folder 11) — Trust / testimonials — SYNTHESIS variant
 *
 * Spec: specs/onboarding-rebuild.md → Act 2 step 10 (placeholder slot)
 *
 * PLACEHOLDER as of 2026-05-17. Mason locked Slot C placement (right after
 * Founder note, before Profile data) so the brand block reads as one moment:
 * founder (who) → testimonials (who else). Both placeholders today; real
 * content fills in when real testimonials exist.
 *
 * Structure intentionally light:
 *   - Heading slot (one line)
 *   - 3 testimonial card slots (bracket stubs make placeholders obvious)
 *   - Continue CTA
 *
 * When real content lands:
 *   - Replace heading bracket with real copy
 *   - Drop bracket-stub testimonial bodies for actual quotes
 *   - Keep cap at 3 (more dilutes; less feels thin)
 *   - Add avatars / name initials when available
 *   - Consider removing the PLACEHOLDER eyebrow once filled in
 */

import ContinueButton from '@/components/onboarding/ContinueButton'

const TESTIMONIAL_SLOTS = [
  {
    quote: 'What they liked, how it helped, what changed.',
    name: 'Name',
    role: 'Role / Church / Where they’re at',
  },
  {
    quote: 'What they liked, how it helped, what changed.',
    name: 'Name',
    role: 'Role / Church / Where they’re at',
  },
  {
    quote: 'What they liked, how it helped, what changed.',
    name: 'Name',
    role: 'Role / Church / Where they’re at',
  },
]

export default function TrustSynthesis({ onContinue }) {
  return (
    <div className="w-full max-w-xl md:max-w-2xl lg:max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
      <div className="text-center mb-7">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[var(--gold)] font-semibold mb-3">
          Placeholder · fill before launch
        </p>
        <h1 className="font-heading text-[26px] sm:text-[30px] text-[var(--text-primary)] leading-[1.2]">
          [ Headline — e.g. &ldquo;Trusted by Christians growing in their walk.&rdquo; ]
        </h1>
      </div>

      <div className="space-y-3 mb-8">
        {TESTIMONIAL_SLOTS.map((t, i) => (
          <div
            key={i}
            className="rounded-xl p-4"
            style={{
              background: 'var(--bg-surface)',
              border: '1px solid var(--glass-border)',
              boxShadow: '0 1px 2px rgba(0,0,0,0.18)',
            }}
          >
            <p className="text-[14px] italic text-[var(--text-primary)] leading-relaxed mb-2">
              &ldquo;[ Testimonial #{i + 1} — {t.quote} ]&rdquo;
            </p>
            <p className="text-[12px] text-[var(--text-muted)]">
              &mdash; [ {t.name} #{i + 1} ], [ {t.role} ]
            </p>
          </div>
        ))}
      </div>

      <div className="flex justify-center">
        <ContinueButton onClick={onContinue}>Continue</ContinueButton>
      </div>
    </div>
  )
}
